import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocViewerComponent, DocViewerData } from '../components/doc-viewer/doc-viewer.component';

/**
 * DocViewerService is a service for opening the document viewer dialog with a specific document
 */
@Injectable({
    providedIn: 'root'
})
export class DocViewerService {
    /** Dependency injections */
    private readonly dialog = inject(MatDialog);

    /**
     * Opens the document viewer dialog with the specified document data
     * @param data Data for the document viewer
     * @returns Dialog ref
     */
    public openDocument(data: DocViewerData): MatDialogRef<DocViewerComponent> {
        return this.dialog.open(DocViewerComponent, {
            data,
            panelClass: 'doc-viewer-dialog',
            disableClose: false,
            autoFocus: false,
            restoreFocus: true,
            height: 'auto'
        });
    }

    /**
     * Opens the document viewer dialog with the specified PDF document
     * 
     * @param url URL of the PDF document
     * @param title Optional title for the document
     * @returns Dialog ref
     */
    public openPdf(url: string, title?: string): MatDialogRef<DocViewerComponent> {
        return this.openDocument({
            documentUrl: url,
            documentType: 'pdf',
            title
        });
    }

    /**
     * Opens the document viewer dialog with the specified image document
     * 
     * @param url URL of the image document
     * @param title Optional title for the document
     * @returns Dialog ref
     */
    public openImage(url: string, title?: string): MatDialogRef<DocViewerComponent> {
        return this.openDocument({
            documentUrl: url,
            documentType: 'image',
            title
        });
    }
}